import comp from "./NoResponseComponent";
export default comp;
